import React from 'react';
import { bool } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import { isScrollingDisabled } from '../../../ducks/UI.duck';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  Page,
  NamedLink,
  NamedRedirect,
  SupportChatWidget,
  Icon,
} from '../../../components';
import config from '../../../config';
import classNames from 'classnames';

import { helpContentFor } from '../HelpPage.helpers';

import TopbarContainer from '../../TopbarContainer/TopbarContainer';
import css from './TopicPage.module.css';

const getArticleIndex = index => index + 1;

const Navigation = props => {
  const { topic } = props;
  return (
    <div className={css.navigation}>
      <ul className={css.navigationLinks}>
        <li className={classNames(css.navigationLinkActive, css.navigationLink)}>
          <NamedLink name="HelpPage">
            <FormattedMessage id="TopicPage.toHelpPage" />
          </NamedLink>
        </li>
        <li>
          <Icon name="chevronRight" size={12} />
        </li>
        <li className={css.navigationLink}>{topic.label}</li>
      </ul>
    </div>
  );
};

const Article = props => {
  const { article, topic, articleIndex } = props;
  return (
    <li className={css.article}>
      <h3 className={css.articleTitle}>
        <NamedLink
          className={css.articleTitleLink}
          name="ArticlePage"
          params={{ topicId: topic.key, articleId: article.key }}
        >
          <FormattedMessage
            id="TopicPage.articleTitle"
            values={{ index: articleIndex, title: article.label }}
          />
        </NamedLink>
      </h3>
    </li>
  );
};

const TopicPageComponent = props => {
  const { intl, scrollingDisabled, params } = props;
  const helpConfig = helpContentFor(intl.locale);

  const topics = helpConfig.topics;
  const topicId = params.topicId;
  const topic = topics.find(t => t.key === topicId);

  if (!topicId || !topic) {
    return <NamedRedirect name="NotFoundPage" />;
  }

  const articles = helpConfig.articles.filter(a => a.topic === topicId);

  const schemaTitle = intl.formatMessage(
    {
      id: 'TopicPage.schemaTitle',
    },
    {
      siteTitle: config.siteTitle,
      topic: topic.label,
    }
  );
  return (
    <Page
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'TopicPage',
        name: schemaTitle,
      }}
      scrollingDisabled={scrollingDisabled}
      currentPage="TopicPage"
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <div className={css.pageContent}>
            <div className={css.pageContentFlex}>
              <Navigation topic={topic} />
              <div className={css.pageContentHeader}>
                <h1 className={css.pageTitle}>{topic.label}</h1>
                <p className={css.pageSubTitle}>{topic.description}</p>
              </div>
              <ul className={css.articles}>
                {articles.map((a, i) => {
                  const articleIndex = getArticleIndex(i);
                  return (
                    <Article key={a.key} article={a} topic={topic} articleIndex={articleIndex} />
                  );
                })}
              </ul>
            </div>
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
          <SupportChatWidget />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

TopicPageComponent.propTypes = {
  intl: intlShape.isRequired,
  scrollingDisabled: bool.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TopicPage = compose(connect(mapStateToProps), injectIntl)(TopicPageComponent);

export default TopicPage;
